
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-secondary-menu--default--display:flex;
  --sic-secondary-menu--default--flex-direction:row;
  --sic-secondary-menu--default--justify-content:flex-start;
  --sic-secondary-menu--default--align-items:center;
  --sic-secondary-menu--default--flex-wrap:nowrap;
  --sic-secondary-menu--default--gap:var(--spacing-3);
  --sic-secondary-menu--default--padding:var(--spacing-0);
  --sic-secondary-menu--default--margin:var(--spacing-0);
  --sic-secondary-menu--default--font-family:var(--ff-body);
  --sic-secondary-menu--default--font-size:14px;
  --sic-secondary-menu--default--font-weight:700;
  --sic-secondary-menu--default--line-height:1.5em;

  --sic-secondary-menu-item--default--padding:var(--spacing-0);
  --sic-secondary-menu-item--default--margin:var(--spacing-0);

  --sic-secondary-menu-item-link--default--padding:var(--spacing-04) var(--spacing-06);
  --sic-secondary-menu-item-link--default--margin:var(--spacing-0);
  --sic-secondary-menu-item-link--default--color:var(--color-neutral-dark);
  --sic-secondary-menu-item-link--default--background:transparent;
  --sic-secondary-menu-item-link--default--border-color:transparent;
  --sic-secondary-menu-item-link--default--border-top-width:5px;
  --sic-secondary-menu-item-link--default--border-right-width:0;
  --sic-secondary-menu-item-link--default--border-bottom-width:0;
  --sic-secondary-menu-item-link--default--border-left-width:0;


  --sic-secondary-menu-item-link--default--color--hover:var(--sic-secondary-menu-item-link--default--color);
  --sic-secondary-menu-item-link--default--background--hover:var(--color-primary-lightest);
  --sic-secondary-menu-item-link--default--border-color--hover:var(--color-primary-default);
  --sic-secondary-menu-item-link--default--border-width--hover:var(--sic-secondary-menu-item-link--default--border-width);
  --sic-secondary-menu-item-link--default--border-top-width--hover:var(--sic-secondary-menu-item-link--default--border-top-width);
  --sic-secondary-menu-item-link--default--border-right-width--hover:var(--sic-secondary-menu-item-link--default--border-right-width);
  --sic-secondary-menu-item-link--default--border-bottom-width--hover:var(--sic-secondary-menu-item-link--default--border-bottom-width);
  --sic-secondary-menu-item-link--default--border-left-width--hover:var(--sic-secondary-menu-item-link--default--border-left-width);

  --sic-secondary-menu-item-link--default--color--focus:var(--sic-secondary-menu-item-link--default--color);
  --sic-secondary-menu-item-link--default--background--focus:var(--color-primary-lightest);
  --sic-secondary-menu-item-link--default--border-color--focus:var(--color-primary-default);
  --sic-secondary-menu-item-link--default--border-top-width--focus:var(--sic-secondary-menu-item-link--default--border-top-width);
  --sic-secondary-menu-item-link--default--border-right-width--focus:var(--sic-secondary-menu-item-link--default--border-right-width);
  --sic-secondary-menu-item-link--default--border-bottom-width--focus:var(--sic-secondary-menu-item-link--default--border-bottom-width);
  --sic-secondary-menu-item-link--default--border-left-width--focus:var(--sic-secondary-menu-item-link--default--border-left-width);

  --sic-secondary-menu-item-link--default--color--active:var(--sic-secondary-menu-item-link--default--color);
  --sic-secondary-menu-item-link--default--background--active:var(--color-primary-lightest);
  --sic-secondary-menu-item-link--default--border-color--active:var(--color-primary-default);
  --sic-secondary-menu-item-link--default--border-top-width--active:var(--sic-secondary-menu-item-link--default--border-top-width);
  --sic-secondary-menu-item-link--default--border-right-width--active:var(--sic-secondary-menu-item-link--default--border-right-width);
  --sic-secondary-menu-item-link--default--border-bottom-width--active:var(--sic-secondary-menu-item-link--default--border-bottom-width);
  --sic-secondary-menu-item-link--default--border-left-width--active:var(--sic-secondary-menu-item-link--default--border-left-width);
}
`;